<img class="maintenance-bg-image" src="assets/images/maintenance/maintenance_bg.jpg"/>
<p class="maintenance-text">Sitio en mantenimiento, en breve estaremos disponibles.<br></p>
<p style="font-size: 16px;position: absolute;right: 20px;top: 20px">Quizás esté buscando nuestro <a href="https://ibec.edu.uy/">sitio</a> para Uruguay?<p>

<div *ngIf="access" class="maintenance-access">
  <div class="p-inputgroup">
    <input type="password" pInputText placeholder="Clave" [(ngModel)]="password">
    <button (click)="grantAccess()" type="button" pButton pRipple icon="pi pi-lock-open" styleClass="p-button-warn"></button>
  </div>
</div>
